import { render, staticRenderFns } from "./ProductNike.vue?vue&type=template&id=5e9c8010&"
import script from "./ProductNike.vue?vue&type=script&lang=js&"
export * from "./ProductNike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports